import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { createTRPCClient, httpLink } from "@trpc/client";
import type { TRPCRouter } from "api-client/legacy-trpc";

import { env } from "src/env";

interface GetLinksOptions {
  cookie?: string;
}

function getLinks(options?: GetLinksOptions) {
  return [
    httpLink({
      url: env.VITE_APP_API_URL,
      headers({ op }) {
        const cookie = String((options?.cookie || op.context?.cookie) ?? "");
        return {
          cookie: cookie || undefined,
        };
      },
      async fetch(url, options) {
        const response = await fetch(url, {
          ...options,
          credentials: "include",
        });
        return response;
      },
    }),
  ];
}

export const trpcClient = createTRPCClient<TRPCRouter>({
  links: getLinks(),
});

export type TRPCClient = typeof trpcClient;

interface GetTRPCClientOptions {
  cookie?: string;
}

export const getTRPCClient = createIsomorphicFn()
  .client<[GetTRPCClientOptions?], TRPCClient>(() => {
    return trpcClient;
  })
  .server((args) => {
    if (args && "cookie" in args) {
      const serverTRPCClient: TRPCClient = createTRPCClient<TRPCRouter>({
        links: getLinks({ cookie: args?.cookie }),
      });
      return serverTRPCClient;
    }

    const request = getRequest();

    const cookie = request.headers.get("Cookie") ?? "";
    const serverTRPCClient: TRPCClient = createTRPCClient<TRPCRouter>({
      links: getLinks({ cookie: cookie }),
    });

    return serverTRPCClient;
  });
